import type { BranchState } from '../lib/branchState'
import { requestBannerCount } from '../lib/pendingRequests'
import { Icon } from './icons'
import { useStaffText } from './StaffText'
import '../styles/hall.css'

/**
 * "N requests", for whoever may decide them. Shown on every staff screen of
 * the branch — Counter, Reception — while the branch has an undecided desk
 * request and this person holds status.approve (spec section 1, "Live
 * views"). Not on the Floor itself: that is where the list this links to
 * already lives on screen.
 *
 * role="status" for the reason QueueAlertBanner's is: it is news that arrives
 * and clears by itself over the live channel, not something this screen did.
 * `quiet` draws it the same way QueueAlertBanner's does, for a screen that
 * already carries other notices in the same strip.
 */
export function RequestBanner({
  state,
  permissions,
  viewerStaffId,
  branchId,
  onNavigate,
  quiet = false,
}: {
  state: BranchState | null
  permissions: readonly string[]
  /** The signed-in person: their own request is not theirs to decide. */
  viewerStaffId?: string
  /** Carried into the link, so the Floor opens already on this branch. */
  branchId?: string
  onNavigate: (to: string) => void
  quiet?: boolean
}) {
  const { say } = useStaffText()
  const n = requestBannerCount(state?.requests, permissions, viewerStaffId)
  if (n === 0) return null
  return (
    <ul className={quiet ? 'hall-requests hall-requests--quiet' : 'hall-requests'}>
      <li className="hall-request" role="status">
        <Icon name="clock" size={16} />
        <button
          type="button"
          className="hall-request__link"
          onClick={() => onNavigate(branchId ? `/floor?branch=${encodeURIComponent(branchId)}` : '/floor')}
        >
          {say('hall.requests', { n })}
        </button>
      </li>
    </ul>
  )
}
